import { xcss } from '@atlaskit/primitives';

export const LabelContainer = xcss({
  textAlign: 'left',
  paddingTop: 'space.150',
});

export const LabelSelectContainer = xcss({
  display: 'flex',
  justifyContent: 'space-between',
  paddingTop: 'space.050',
  alignItems: 'center',
  textAlign: 'left',
});
